export default () => {
  return new Date().getTime().toString()
}
